import elLocale from 'element-ui/lib/locale/lang/en';

export default {
	// Element UI built-in strings (message box, form defaults, ...)
	el: elLocale.el,

	common: {
		loading: 'Loading...',
		error: 'Error',
		close: 'Close',
		cancel: 'Cancel',
		send: 'Send',
		sending: 'Sending...',
		signIn: 'Sign in',
		signUp: 'Sign up',
		backToLogin: 'Back to login',
		downloadRambox: 'Download Rambox',
		returnToRamboxLogin: 'Return to Rambox login',
	},

	notifications: {
		unsupportedVersion:
			'Unsupported version: You are using an outdated version, please update to continue using Rambox.',
	},

	auth: {
		loading: {
			authenticating: 'Authenticating...',
			settingUpUser: 'Setting up user...',
			sendingVerificationEmail: 'Sending verification Email...',
			gettingOrganizationData: 'Getting organization data...',
		},
		version: {
			notAllowedTitle: 'Version not allowed',
			notAllowedSubtitle: 'Your Rambox version is no longer supported, please update it before get logged.',
			checkForUpdates: 'Check for updates',
			updateHint:
				'You can do this from the About section or download the latest version from our website www.rambox.app.',
		},
		dashboard: {
			hello: 'Hello {name}!',
			welcome: 'Welcome to your dashboard',
			downloadDesktopApp: 'Download the desktop app',
			billingPortal: 'Billing portal',
			helpCenter: 'Help Center',
		},
		facebook: {
			linkPrompt:
				'In order to add {provider} as a trusted provider to your Rambox account, you must sign in with one of your previously used login methods:',
			passwordPlaceholder: 'Type your Rambox password',
			continueWithGoogle: 'Continue with Google',
			linked: '{provider} linked to {email}',
			or: 'OR',
		},
		enterprise: {
			button: 'Enterprise',
			drawerTitle: 'Enterprise login',
			placeholder: 'your-company-id',
		},
		signInTo: 'Sign in to',
		signUpTo: 'Sign up to',
		forIndividuals: 'For individuals',
		forBusinesses: 'For Businesses',
		providers: {
			saml: 'Sign in with {provider}',
		},
		divider: {
			signin: 'OR USE YOUR ACCOUNT',
			signup: 'OR USE YOUR EMAIL',
			noAccount: 'DON’T HAVE AN ACCOUNT?',
		},
		form: {
			email: 'E-mail',
			password: 'Password',
			forgotPassword: 'Forgot password?',
		},
		signUpForRambox: 'Sign up for Rambox',
		alreadyHaveAccount: 'Already have an account? Sign in',
		legal: {
			text: 'By continuing with Google, Facebook or your email, you accept the {terms} and the {privacy}.',
			terms: 'Terms of use',
			privacy: 'Privacy Policy',
		},
		validation: {
			emailRequired: 'E-mail address is required.',
			emailInvalid: 'Please input a correct email address.',
			passwordRequired: 'Password is required.',
			passwordMin: 'Minimum password length is 6.',
		},
		resetPrompt: {
			title: 'Forgot password',
			message: 'Please input your e-mail.',
			invalidEmail: 'Invalid e-mail format.',
			sent: 'A reset password email has been sent to {email}',
		},
		verifyEmail: {
			text:
				'Please verify your account by clicking the link we sent you to {email} before get logged. If you don’t receive it, follow the steps in',
			article: 'this article',
			yourEmail: 'your email',
		},
		errors: {
			organizationNotFound: 'Organization not found',
			freshdesk: 'There was an error while authenticating. Please go to the Support Portal and try again...',
			noEmailScope:
				'We could not get your email, we need it to identify your account. Please, log in again and allow the email scope.',
			noTenantId: 'The organization is not properly configured.',
		},
	},

	actionHandler: {
		loading: {
			title: 'Please wait...',
			subtitle: 'Validating your link.',
		},
		verifySuccess: {
			title: 'Email verified!',
			ready: 'Your account is ready to go.',
			redirecting: 'Redirecting in {count} second... | Redirecting in {count} seconds...',
			readyNoRedirect:
				'Your account is ready. You can now open the Rambox desktop app and sign in with the same account.',
		},
		reset: {
			title: 'Reset your password',
			settingFor: 'Setting new password for {email}',
			newPassword: 'New password',
			repeatPassword: 'Repeat new password',
			submit: 'Set new password',
		},
		resetSuccess: {
			title: 'Password updated!',
			text: 'Your password has been changed successfully. You can now sign in with your new password.',
		},
		signinEmail: {
			title: 'Confirm your email',
			text: 'Please enter the email address where you received this invitation.',
			placeholder: 'Your email address',
			continue: 'Continue',
		},
		setPassword: {
			title: 'Set your password',
			createFor: 'Create a password for {email}',
			newPassword: 'New password',
			confirmPassword: 'Confirm password',
			submit: 'Set password & continue',
		},
		signinSuccess: {
			title: 'Account ready!',
			text: 'Your account has been set up successfully.',
			enterpriseInfo:
				'Once you start Rambox, be sure to select the {enterpriseLogin} option and enter the following enterprise ID:',
			enterpriseLogin: 'Enterprise login',
			copied: 'Copied!',
		},
		expired: {
			title: 'Link expired',
			text: 'This link has expired. Please request a new one.',
		},
		resend: {
			placeholder: 'Enter your email',
			button: 'Resend verification email',
			sent: 'Email sent! Check your inbox.',
		},
		error: {
			title: 'Invalid link',
		},
		validation: {
			passwordRequired: 'Password is required.',
			passwordMin: 'Minimum password length is 6.',
			repeatPassword: 'Please repeat your password.',
			passwordsDoNotMatch: 'Passwords do not match.',
			emailRequired: 'Email is required.',
			emailInvalid: 'Please enter a valid email address.',
		},
		errors: {
			invalidLink: 'Invalid or missing action link.',
			noAuthenticatedUser: 'No authenticated user found.',
			couldNotSetPassword: 'Could not set password. Please try again.',
			emailMismatch: 'The email address does not match this invitation link.',
			signInFailed: 'Sign-in failed. Please try again.',
			couldNotReset: 'Could not reset password. Please try again.',
			linkInvalidOrUsed: 'The link is invalid or has already been used.',
		},
	},

	website: {
		goBackToWebsite: 'Go back to website',
		title: 'Why you should create an account?',
		benefits: {
			sync: 'To synchronize your workspace all over your computers.',
			trial: 'Get 30 days trial of the Pro plan with all the features.',
			noCreditCard: 'You don’t need a credit card or any other info.',
			freePlan: 'After the trial, you can continue using the Basic plan for FREE.',
			easyRemoval: 'Removing your account is easy if you decide not to continue using Rambox.',
		},
		downloadApp: 'Already have an account? Download the app',
		enterprise: 'Are you a business? Sign up here for Rambox Enterprise',
	},

	// Firebase error codes. Any code not listed here falls back to the raw
	// message returned by Firebase.
	firebase: {
		'auth/invalid-email': 'The email address is not valid.',
		'auth/user-disabled': 'This account has been disabled. Please contact support.',
		'auth/user-not-found': 'There is no account with this email address.',
		'auth/wrong-password': 'The email or the password is incorrect.',
		'auth/invalid-credential': 'The email or the password is incorrect.',
		'auth/invalid-login-credentials': 'The email or the password is incorrect.',
		'auth/missing-password': 'Please enter your password.',
		'auth/email-already-in-use': 'There is already an account with this email address.',
		'auth/weak-password': 'The password is too weak. Use at least 6 characters.',
		'auth/operation-not-allowed': 'This sign in method is not enabled.',
		'auth/too-many-requests': 'Too many attempts. Please wait a few minutes and try again.',
		'auth/network-request-failed': 'Network error. Please check your connection and try again.',
		'auth/popup-closed-by-user': 'The sign in window was closed before finishing.',
		'auth/cancelled-popup-request': 'The sign in request was cancelled.',
		'auth/requires-recent-login': 'Please sign in again to complete this action.',
		'auth/expired-action-code': 'This link has expired. Please request a new one.',
		'auth/invalid-action-code': 'This link is invalid or has already been used.',
		'auth/account-exists-with-different-credential':
			'There is already an account with this email address using a different sign in method.',
		'auth/internal-error': 'Something went wrong. Please try again.',
	},
};
